export default "__VITE_ASSET___gnDFL0G__"